// src/services/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAuIYaTgq_bs2yodmpSlyZkqt-gLO1M760",
  authDomain: "selenne-business-suite.firebaseapp.com",
  projectId: "selenne-business-suite",
  storageBucket: "selenne-business-suite.firebasestorage.app",
  messagingSenderId: "906336605782",
  appId: "1:906336605782:web:61064cf21ecdfb0724cdf7"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Auth, Firestore, Storage, and Functions instances
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Connect to the Functions emulator when running locally
//if (window.location.hostname === 'localhost') {
 // connectFunctionsEmulator(functions, '127.0.0.1', 5001);
//}
